import { ActionTypeList } from '../../constants/index'

const initialState = {
    loading: false,
    error: "",
    userDetail: {
        userName: '',
        userId: '',
        userEmail: '',
        jobTitle: '',
        password: '',
        role: ''
    },
};

const currentUserDetailPayload = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypeList.USER_SETTING_DETAIL_FETCHED:
            return {
                loading: false,
                userDetail: action.payload,
                error: ""
            };
        case ActionTypeList.USER_SETTING_FETCH_DETAIL:
            return {
                loading: true,
                userDetail: {},
                error: action.payload
            };
        case ActionTypeList.USER_SETTING_NEW_FLAG_TOGGLED:
        case ActionTypeList.USER_SETTING_RESET_USER_DETAIL_INPUT_FIELDS:

            return {
                loading: false,
                userDetail: {
                    ...initialState.userDetail
                }
            };
        case ActionTypeList.USER_SETTING_FIELD_UPDATED:
            const payload = action.payload;

            return {
                loading: false,
                userDetail: { ...state.userDetail, [payload.fieldName]: payload.fieldValue },
                error: ""
            };
        default:
            return state;
    }
}

export default currentUserDetailPayload;